module.exports = __webpack_public_path__ + "img/quick-label-print-button-en.386a44a7.png";